import { Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import crossIcon from "../../assets/images/CrossInActive.svg";
import LabelComponent from "../UniversalComponents/LabelComponent";
import InputComponent from "../UniversalComponents/InputComponent";
import TextAreaComponent from "../UniversalComponents/TextAreaComponent";
import Button from "../UniversalComponents/DefaultButton";

const validationRules = {
  name: {
    required: true,
    errorMessage: "Cannot be left blank",
  },
};

const initialFormData = {
  name: "",
  description: "",
  // status: "", // Uncomment if needed later
};

const AddManageListDialog = ({ open, closePopup, handelsave, editData }) => {
  const { token } = useRequireAuth();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState(initialFormData);

  const { errors, isFormValid } = useCustomFormValidation(formData, validationRules);

  // Close on Escape key
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };
    window.addEventListener("keydown", handleEscKey);
    return () => window.removeEventListener("keydown", handleEscKey);
  }, [closePopup]);

  useEffect(() => {
    if (editData) {
      setFormData({
        name: editData?.list_name || "",
        description: editData?.description || "",
      });
    }
  }, [editData]);

  //   useEffect(() => {
  //   if (!editData) {
  //     if (formData.name !== "" || formData.description !== "") {
  //       setFormData(initialFormData);
  //     }
  //     return;
  //   }

  //   // Only update if different to prevent loop
  //   if (
  //     formData.name !== (editData.list_name || "") ||
  //     formData.description !== (editData.description || "")
  //   ) {
  //     setFormData({
  //       name: editData.list_name || "",
  //       description: editData.description || "",
  //     });
  //   }
  // }, [editData, formData]);

  // const popupRef = useClickOutside(() => {
  //   closePopup();
  // });

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isFormValid()) return;

    const payload = {
      list_name: formData.name,
      description: formData.description,
      id: editData?.id,
      // tableuuid: editData?.uuid || editData?.tableuuid,
    };

    handelsave(payload);
  };

  return (
    <Dialog open={open} onClose={closePopup} fullWidth>
      <div
        className="relative mt-18 bg-white h-full w-full flex flex-col font-popns rounded-md overflow-hidden no-scrollbar"
        // ref={popupRef}
      >
        <div className="mx-6 flex items-center justify-between py-4 md:py-3 border-BECBD3 rounded-t">
          <h3 className="text-xl text-434852 font-500">{editData ? "Edit" : "Add"} Manage List</h3>
          <button
            onClick={closePopup}
            type="button"
            className="text-454545 hover:text-[#1D4469] text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            aria-label="Close modal"
          >
            <img src={crossIcon} alt="Close" className="hover:bg-[#EBF2F6] w-5 h-5" />
          </button>
        </div>

        <form
          className="w-full grow min-h-0 pt-3 border-t flex flex-col justify-between"
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="grow min-h-0 px-6">
            <div className="flex flex-col gap-y-2">
              {/* Name Field */}
              <div className="w-full">
                <LabelComponent htmlFor="name" labelText="Name" size="small" isMandatory />
                <InputComponent
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleFieldChange}
                  mandatory
                  error={errors?.name}
                />
              </div>

              {/* Description Field */}
              <div className="w-full">
                <LabelComponent htmlFor="description" labelText="Description" size="small" />
                <TextAreaComponent
                  name="description"
                  id="description"
                  placeholder="Enter Description"
                  value={formData.description}
                  onChange={handleFieldChange}
                  showResizer
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-3 justify-end py-2 pe-5">
            <Button variant="secondary" onClick={closePopup} type="button" size="small">
              Cancel
            </Button>
            <Button variant="primary" type="submit" size="small">
              {editData ? "Update" : "SAVE"}
            </Button>
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default AddManageListDialog;
